(function() {

    'use strict';

	angular.module('vhols-date-input', ['vhols-dates']);

    angular.module('vhols-date-input')

    .constant('NOW', new Date())
    .controller('DateInputController', ['$scope', 'dates', 'NOW', function($scope, dates, NOW) {

        // Custom Config
        var dropDownFormat = "MMM YYYY";
        $scope.selectedMonth = {};
        $scope.monthsToShow = $scope.monthsToShow ? $scope.monthsToShow : 8;

        var noNightsKey = "noNights";

        // Bootstrap UI Config
        $scope.showWeeks = false;
        $scope.opened = false;
        $scope.dateOptions = {
            'starting-day': 1,
            'show-button-bar': false,
            'show-weeks': false
        };
        
        
        function initSelectedDates() {
            $scope.date = NOW;    
            $scope.monthOnView = $scope.date;
        }


        // Specific functions
        $scope.open = function($event) {

            // HACK if month on view is not the same a selected month then reset calendar
            if ( !dates($scope.monthOnView).isSame($scope.date, 'months') ) {
                $scope.monthOnView = $scope.date;
                resetCalendar( document.querySelector('.opened .calendar'), $scope.date );
            }

            $event.preventDefault();
            $event.stopPropagation();

            function isReturningInSameMonthAsDeparting() {
                return dates($scope.minDate).isSame($scope.maxDate, 'months');
            }

            $scope.dateSelections = calculateMonths($scope.monthsToShow, 0); // Get initial months for selector
            $scope.monthsFromStart = setStartIdx();
            $scope.opened = true;

        };

        $scope.monthSelection = function(val) {
            $scope.dateSelections = calculateMonths($scope.monthsToShow, val);
        };

        $scope.monthMove = function(step) {
            $scope.monthOnView = dates(new Date()).addMonths($scope.monthsFromStart).asDate();
            moveStep(step);
        };

        /*
         * Recalculate the drop down boxes months from the minimum allowed start date
         * idx is the index of the month in the array
         * move is the number to feed to the bootstrap ui move function - this is what sets the new month view
         */
        function calculateMonths(toShow, selectedIdx) {

            var monthsArr = [];
            var startPoint = new Date();

            for (var i = 0; i <= toShow; i++) {
                var dt = {
                    "label": dates(startPoint).addMonths(i).format(dropDownFormat),
                    "idx": i,
                    "move": i - selectedIdx
                };

                monthsArr.push(dt);
            }

            $scope.selectedMonth = monthsArr[selectedIdx];

            return monthsArr;
        }

        // HACK into Bootstrap ui's move function
        function moveStep(step) {
            // Move the datepicker to the selected index
            if (angular.element(document.querySelector('.opened .calendar')).length > 0) {
                angular.element(document.querySelector('.opened .calendar')).scope().$parent.move(step);
            }
        }

        function resetCalendar(calElm, newDate) {
            // reset calendar to a specific date
            if (angular.element(calElm).length > 0) {
                angular.element(calElm).scope().$parent.select(newDate);
            }
        }

        // Set the selected date
        function setStartIdx() {

            var dt = $scope.popupType === 'end' ? $scope.date : $scope.monthOnView;

            var idx = $scope.dateSelections.filter(function (obj) {
                return obj.label ==  dates(dt).format(dropDownFormat);
            })[0];

            if (idx) {
                $scope.dateSelections = calculateMonths($scope.monthsToShow, idx.idx);
                return idx.idx;
            }
        }


        // Watch for date changes
        $scope.$watch('watchCheckIn', function(newDate) {
            if (typeof newDate !== "undefined") {
                $scope.date = dates(newDate).addDays($scope.noNights).asDate();
                $scope.minDate = dates(newDate).addDays($scope.minNights).asDate();
                $scope.maxDate = dates(newDate).addDays($scope.maxNights).asDate();
            }
        });
    }]);
    
    angular.module('vhols-date-input').directive('vholsDateInput', [function() {
        return {
            replace: true,
            scope: {
                'placeholder': '@',
                'dateName': '=', // The name for the hidden field - allows field to be submitted
                'date': '=', // The date value returned from the date picker
                'minDate': '=', // The datepicker's minimum value
                'maxDate': '=', // The datepicker's maximum value
                'monthsToShow': '=', // The months available to show (+12)
                'label': '@',
                'format': '@',
                'icon': '=',
                'dateInputId': '@' // the id of the input field
            },
            templateUrl: 'vholsdateinput.html',
            controller: 'DateInputController'
        };
    }]);

    /*
     This directive is a workaround for a bug in angular-ui 1.3.x with the initial date format. This gave me so much pain.
     https://github.com/angular-ui/bootstrap/issues/2659
     */
    angular.module('vhols-date-input').directive('datepickerPopup', function () {
        return {
            restrict: 'EAC',
            require: 'ngModel',
            link: function(scope, element, attr, controller) {
                //remove the default formatter from the input directive to prevent conflict
                controller.$formatters.shift();
            }
        }
    });

})();

'use strict';

angular.module('vhols-date-input').run(['$templateCache', function($templateCache) {

  $templateCache.put('vholsdateinput.html', '<div class="date-picker-wrapper" ng-class="{\'show-icon\': icon}">\n    <label for="{{label}}">{{label}}</label>\n    <div class="wrapper-icon">\n        <i class="icon-sp-calendar" ng-if="icon"></i>\n        <input id="{{label}}" type="text" class="form-control"\n           ng-model="date"\n           is-open="opened"\n           min-date="minDate"\n           max-date="maxDate"\n           months-to-show="$parent.monthsToShow"\n           datepicker-popup="{{format}}"\n           placeholder="{{placeholder}}"\n           dateSelections="dateSelections"\n           datepicker-options="dateOptions"\n           ng-required="true"\n           datepicker-append-to-body="true"\n           show-button-bar="false"\n           ng-click="open($event)" />\n    </div>    \n</div>');

  $templateCache.put('template/datepicker/datepicker.html', '<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)" ng-init="monthsToShow = $root.monthsToShow">\n    <span ng-init="monthSelection = $parent.monthSelection"></span>\n    <span ng-init="selectedMonth = $parent.selectedMonth"></span>\n    <daypicker ng-switch-when="day" tabindex="0"></daypicker>\n    <monthpicker ng-switch-when="month" tabindex="0"></monthpicker>\n    <yearpicker ng-switch-when="year" tabindex="0"></yearpicker>\n</div>');

  $templateCache.put('template/datepicker/day.html', '<div class="calendar">\n    <table>\n        <thead>\n        <tr class="headings">\n            <th ng-show="showWeeks" class="text-center"></th>\n            <th ng-repeat="label in labels track by $index" class="text-center"><small aria-label="{{label.full}}">{{label.abbr}}</small></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="row in rows track by $index">\n            <td ng-show="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n            <td ng-repeat="(daynum, dt) in row track by dt.date" ng-class="{\'direct-flight\' : directFlight(dt.date) && !dt.secondary && !dt.disabled, \'foof\': dt.secondary}" class="text-center day-box" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n                <button type="button"\n                        class="btn btn-default btn-sm btn-sq btn-dt-select"\n                        ng-class="{\'btn-info\': dt.selected, \'direct-flight\' : directFlight(dt.date), \'btn-secondary\' : dt.secondary}"\n                        ng-click="select(dt.date)"\n                        ng-disabled="dt.disabled">\n                             <span class="day-name">{{labels[daynum].abbr}}</span>\n                            {{dt.label | number}}\n                </button>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n');

  $templateCache.put('template/datepicker/popup.html', '<div class="modal fade in datepicker {{$parent.popupType}}" ng-click="isOpen = false" ng-show="isOpen" ng-class="{\'opened\': isOpen}" ng-style="{display: (isOpen && \'block\') || \'none\'}">\n    <div class="modal-dialog" stop-event="touchend" ng-init="monthsLimit = $parent.monthsToShow" ng-click="$event.stopPropagation();">\n\n        <div class="modal-content modal-content-calendar">\n            <div class="calendarHeader">\n                <div class="dialogHeader">\n                    <div class="row">\n                        <div class="col-xs-8">\n                            <span class="title">{{$parent.dateLabel}}</span>\n                        </div>\n                        <div class="col-xs-4 text-right">\n                            <a href="" class="vIconAlign" ng-click="isOpen = false"><span class="text">{{closeText}}</span> <i class="icon-close"></i></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div>\n                <div class="row dateHeader">\n                    <div class="col-xs-4">\n                        <button class="control btn btn-link pull-left"\n                                type="button"\n                                disabled="disabled"\n                                ng-click="$parent.monthsFromStart = $parent.monthsFromStart - 1;$parent.monthMove(-1);$parent.monthSelection($parent.monthsFromStart);"\n                                ng-disabled="$parent.monthsFromStart < 1">\n                            <i class="du-icon-chevron-left"></i>\n                            <span class="month-select-text previous-month-select">Previous <span class="extended-text">month</span></span>\n                        </button>\n                    </div>\n                    <div class="col-xs-4 text-center">\n                        <div class="month-selector pl-select-box">\n                            <select\n                                    stop-event="touchend"\n                                    class="form-control"\n                                    id="month-selector"\n                                    ng-model="$parent.selectedMonth"\n                                    ng-options="item.label for item in $parent.dateSelections track by item.move"\n                                    ng-change="$parent.monthsFromStart = $parent.selectedMonth.idx;$parent.monthMove($parent.selectedMonth.move);$parent.monthSelection($parent.monthsFromStart);"></select>\n                        </div>\n                    </div>\n                    <div class="col-xs-4">\n                        <button class="control btn btn-link pull-right"\n                                type="button"\n                                ng-click="$parent.monthsFromStart = $parent.monthsFromStart + 1;$parent.monthMove(1);$parent.monthSelection($parent.monthsFromStart);"\n                                ng-disabled="$parent.monthsFromStart >= $parent.monthsToShow">\n                            <i class="du-icon-chevron-right"></i>\n                            <span class="month-select-text next-month-select">Next <span class="extended-text">month</span></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-transclude></div>\n        </div>\n    </div>\n</div>\n');

}]);